// removed by extract-text-webpack-plugin
module.exports = {"calendar":"CalendarPart_calendar---sbox","date-input":"CalendarPart_date-input---sbox","dateInput":"CalendarPart_date-input---sbox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CalendarPart/styles.less
// module id = 586
// module chunks = 0